'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n        opacity: 1;\n        transform: none;\n        visibility: visible;\n      '], ['\n        opacity: 1;\n        transform: none;\n        visibility: visible;\n      ']),
    _templateObject2 = _taggedTemplateLiteral(['\n        opacity: 0;\n        transform: translateY(-100vh);\n        visibility: hidden;\n      '], ['\n        opacity: 0;\n        transform: translateY(-100vh);\n        visibility: hidden;\n      ']),
    _templateObject3 = _taggedTemplateLiteral(['\n        opacity: 0;\n        transform: translateY(100%);\n        visibility: hidden;\n      '], ['\n        opacity: 0;\n        transform: translateY(100%);\n        visibility: hidden;\n      ']),
    _templateObject4 = _taggedTemplateLiteral(['\n  z-index: 1000000000;\n  position: fixed;\n  bottom: 0px;\n  left: -65px;\n  ', ';\n  ', ';\n'], ['\n  z-index: 1000000000;\n  position: fixed;\n  bottom: 0px;\n  left: -65px;\n  ', ';\n  ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _polished = require('polished');

var _Rocket = require('../../Rocket/Rocket');

var _Rocket2 = _interopRequireDefault(_Rocket);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Components


var statusCss = function statusCss(_ref) {
  var status = _ref.status;

  switch (status) {
    case 'prepare':
      return (0, _styledComponents.css)(_templateObject);

    case 'launch':
      return (0, _styledComponents.css)(_templateObject2);

    default:
      return (0, _styledComponents.css)(_templateObject3);
  }
};

var Container = _styledComponents2.default.div(_templateObject4, statusCss, (0, _polished.transitions)('transform .3s ease-in, opacity .3s ease-in, visibility .3s ease-in'));

var RocketLauncher = function RocketLauncher(_ref2) {
  var status = _ref2.status,
      shake = _ref2.shake;
  return _react2.default.createElement(Container, {
    status: status
  }, _react2.default.createElement('div', {
    className: 'shake-constant ' + shake
  }, _react2.default.createElement(_Rocket2.default, {
    flying: status !== null
  })));
};

RocketLauncher.propTypes = {
  status: _propTypes2.default.string,
  shake: _propTypes2.default.string
};
exports.default = RocketLauncher;